var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{staticClass:"bg-default-card",attrs:{"header":_vm.uLang('app.edit'),"header-tag":"h4"}},[_c('faq-form',{attrs:{"id":_vm.id}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }